<template>
  <div class="products-page">
    <BaseImg :title="$t('products.Title')" bgName="bg_products.png">
      <p class="products-intro">{{ $t('products.Intro') }}</p>
    </BaseImg>
    <PublicBreadcrumb />
    <nav class="service-guides" :aria-label="$t('products.GuideTitle')">
      <router-link :to="$siteLink('/rmb-nzd')">{{ $t('products.RmbLink') }}</router-link>
      <router-link :to="$siteLink('/business-payments')">{{ $t('products.BusinessLink') }}</router-link>
      <router-link :to="$siteLink('/large-transfers')">{{ $t('products.LargeLink') }}</router-link>
    </nav>
    <BaseProducts />
    <section class="exchange-section" id="currency-exchange">
      <div class="content-width exchange-inner">
        <div>
          <p class="eyebrow">{{ $t('services.ExchangeLabel') }}</p>
          <h2>{{ $t('services.Exchange') }}</h2>
          <p>{{ $t('services.ExchangeText') }}</p>
          <p>{{ $t('services.ExchangeConditions') }}</p>
          <router-link :to="$siteLink('/contact')" class="service-button">{{ $t('services.DiscussExchange') }}</router-link>
        </div>
        <div class="exchange-checks">
          <h3>{{ $t('products.BeforeTitle') }}</h3>
          <ul>
            <li v-for="check in checks" :key="check">{{ $t(check) }}</li>
          </ul>
          <router-link :to="$siteLink('/faq')" class="text-link">{{ $t('products.ReadFaq') }} <span aria-hidden="true">→</span></router-link>
        </div>
      </div>
    </section>
    <BaseBusiness :isBgGray="true" />
    <PublicTransferGuide />
    <div class="flow-link"><router-link :to="$siteLink('/how-it-works')" class="text-link">{{ $t('products.FlowLink') }} <span aria-hidden="true">→</span></router-link></div>
    <section class="preparation-section" id="transfer-preparation">
      <div class="content-width preparation-inner">
        <div>
          <h2>{{ $t('products.MaterialsTitle') }}</h2>
          <p>{{ $t('products.MaterialsText') }}</p>
          <router-link :to="$siteLink('/kyc-source-of-funds')" class="text-link">{{ $t('products.VerificationLink') }} <span aria-hidden="true">→</span></router-link>
        </div>
        <div>
          <h2>{{ $t('products.PaymentTitle') }}</h2>
          <p>{{ $t('products.PaymentText') }}</p>
          <router-link :to="$siteLink('/security')" class="text-link">{{ $t('products.SafetyLink') }} <span aria-hidden="true">→</span></router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import BaseImg from '@/components/BaseImg.vue'
import PublicBreadcrumb from '@/components/PublicBreadcrumb.vue'
import BaseProducts from '@/components/BaseProducts.vue'
import BaseBusiness from '@/components/BaseBusiness.vue'
import PublicTransferGuide from '@/components/PublicTransferGuide.vue'

export default {
  components: { PublicBreadcrumb, BaseImg, BaseProducts, BaseBusiness, PublicTransferGuide },
  data () {
    return {
      checks: Array.from({ length: 4 }, (_, index) => 'products.Check' + (index + 1))
    }
  }
}
</script>

<style scoped>
.products-page ::v-deep .public-breadcrumb { max-width: 1440px; padding-right: clamp(36px, 7vw, 100px); padding-left: clamp(36px, 7vw, 100px); }
.service-guides { display: flex; flex-wrap: wrap; gap: 12px 16px; max-width: 1440px; margin: 0 auto; padding: 20px clamp(36px, 7vw, 100px) 32px; }
.service-guides a { display: inline-flex; align-items: center; min-height: 44px; padding: 8px 22px; border: 1px solid #163257; border-radius: 100px; font-size: 16px; font-weight: 600; color: #163257; line-height: 1.5; }
.service-guides a:hover { background: #163257; color: #fff; }
.flow-link { max-width: 1240px; margin: -24px auto 32px; padding: 0 clamp(24px, 6vw, 64px); }
.products-intro { max-width: 820px; margin: 20px auto 0; color: #fff; font-size: 20px; line-height: 1.6; text-align: center; }
.content-width { max-width: 1440px; margin: 0 auto; padding: clamp(36px, 7vw, 100px); }
.exchange-section, .preparation-section { color: #163257; background: #fff; }
.exchange-inner, .preparation-inner { display: grid; grid-template-columns: 1fr 1fr; gap: clamp(36px, 6vw, 88px); }
.eyebrow { color: #8a6e29; font-size: 18px; font-weight: 600; }
h2 { font-size: clamp(26px, 2.8vw, 38px); line-height: 1.35; text-wrap: balance; font-weight: 600; color: #163257; margin: 12px 0 24px; }
h3 { font-size: 24px; line-height: 1.4; font-weight: 600; color: #163257; margin: 0 0 20px; }
p, li { font-size: 17px; line-height: 1.75; }
p { margin: 0 0 20px; }
ul { padding-left: 22px; margin: 0 0 24px; }
li { margin-bottom: 12px; }
.exchange-checks { padding-top: 24px; border-top: 1px solid #d9e0e7; }
.service-button { display: inline-flex; align-items: center; justify-content: center; margin-top: 8px; padding: 13px 28px; border-radius: 30px; background: #163257; color: #fff; font-size: 16px; line-height: 1.5; text-align: center; }
.service-button:hover { background: #244971; }
.text-link { color: #163257; text-decoration: underline; text-underline-offset: 5px; font-weight: 600; line-height: 1.7; }
.text-link span { margin-left: 8px; }
.preparation-inner h2 { font-size: clamp(26px, 2.7vw, 36px); }
@media (max-width: 768px) {
  .products-intro { font-size: 16px; margin-top: 16px; }
  .content-width { padding: 36px 6vw; }
  .products-page ::v-deep .public-breadcrumb, .service-guides { padding-right: 6vw; padding-left: 6vw; }
  .service-guides { padding-top: 16px; padding-bottom: 24px; }
  .exchange-inner, .preparation-inner,   p, li { font-size: 16px; }
}
</style>
